import { CSSProperties } from 'react'

export function ActionButton({
    onClick,
    children,
    className = undefined,
    style,
}: {
    onClick: () => void
    children: string
    className?: string | undefined
    style?: CSSProperties
}) {
    return (
        <button
            style={style}
            className={'action-button' + (className ? ` ${className}` : '')}
            onClick={onClick}
        >
            {children}
        </button>
    )
}
